import { Component, OnInit, Input } from '@angular/core';
import { HomeSlider } from '../../../shared/data/slider';
import { MyService } from 'src/app/shared/services/myservice';
import { Router } from '@angular/router';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnInit {

  @Input() sliders: any[];
  @Input() class: string;
  @Input() textClass: string;
  @Input() category: string;
  @Input() buttonText: string;
  @Input() buttonClass: string;

  @Input() advImg:string; 
  
  constructor(private myService: MyService, private router: Router,) {

    // console.log(this.sliders)

    // console.log(this.advImg)
  }

  ngOnInit(): void {

  }

  // routecollect(item) {
  //   console.log(item)    
  //   this.router.navigateByUrl('/shop/collection/left/sidebar/' + item.categoryId);
  //   this.myService._catID.next(item.categoryId);
  //   // console.log(this.router.url)
  // }

  public HomeSliderConfig: any = HomeSlider;

}
